import styled, { css } from "styled-components";

import { BorderColors } from "@abel-technologies-as/components";

const FooterMenuContainer = styled.div`
	max-width: 240px;
`;

const FooterHeader = styled.div`
	padding: 12px 16px;
	border-bottom: 1px solid ${BorderColors.Secondary};
`;

const FooterHeaderTitle = styled.div`
	width: 150px;
	overflow-wrap: break-word;
`;

const FooterBody = styled.div`
	padding: 3px 16px;
	cursor: pointer;
	// width: 300px;
`;

const styleButton = css`
	padding-left: 5px;
	width: 100%;
	text-align: left;

	p {
		width: 100%;
	}
`;

export { FooterMenuContainer, FooterBody, FooterHeader, FooterHeaderTitle, styleButton };
